import React, { useState, useContext, useEffect } from 'react'
import { VistaEmpresasContext } from './VistaEmpresasAdmin'
import { useAdmin } from '../../../context/AdminContext'
import { AreaContext } from '../../../context/AreaContext'
import "./AdminConsultora.scss"
import ModalAreaConsul from '../../Modales/Admin/superAdmin/ModalAreaConsul'
// ui
import { Oval } from 'react-loader-spinner'

export const listaAreasConsulContext = React.createContext()

function ListaAreasConsul() {

    const { user, idEmpresa } = useContext(VistaEmpresasContext)
    const { areas, setAreas } = useContext(AreaContext)

    const { fetchArea, errorArea, setErrorArea } = useAdmin()

    const [modalArea, setModalArea] = useState(false)
    const [objArea, setObjArea] = useState(null)
    const [idArea, setIdArea] = useState(null)

    const [loadingAreas, setLoadingAreas] = useState(true)

    useEffect(()=>{
        fetchArea(user, idEmpresa)
        .then(res => {
            if(res.status !== 0){
                setLoadingAreas(false)
                setErrorArea(res.codeError)
            } else {
                setLoadingAreas(false)
                setAreas(res.objeto)
            }
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const handleModalArea = () => {
        setModalArea(true)
    }

    const handleModalEditArea = (id) => {
        const obj = areas.find((e) => e.id_area === id)
        setObjArea(JSON.stringify(obj))
        setIdArea(id)
        setModalArea(true)
    }

    return (
        <>
            <listaAreasConsulContext.Provider value={{ idArea, setIdArea, objArea, setObjArea }}>
                <ModalAreaConsul show={modalArea} onHide={()=>setModalArea(false)} />
                {loadingAreas ? (
                    <div className='loading__ListaAreas my-3 d-flex flex-column align-items-center justify-content-center'>
                        <Oval
                            visible={true}
                            height="40"
                            width="40"
                            color="#0d6efd"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                        <p className='fw-medium m-0 p-0'>Loading...</p>
                    </div>
                ) : (
                    <>
                        {errorArea ? (
                            <div className='error__ListaAreas py-4 d-flex flex-column align-items-center justify-content-center rounded-3'>
                                <h3 className='text-danger fw-semibold mb-2'>Oops!</h3>
                                <p className='m-0 p-0'>{errorArea}</p>
                            </div>
                        ) : (
                            <>
                                {areas.length === 0 ? (
                                    <div className='container__areas--empty py-4 d-flex flex-column align-items-center rounded-3'>
                                        <h3 className='text-blue-500'>No tienes áreas aún.</h3>
                                        <button onClick={handleModalArea} className='btn btn-sm btn-primary rounded-pill px-3 fw-medium'>+ Agregar área</button>
                                    </div>
                                ) : (
                                    <div className='container__areas'>
                                        <div className='d-flex flex-row align-items-center mb-3'>
                                            <h4 className='text-blue-500 m-0 pe-3'>Áreas</h4>
                                            <div className='d-flex flex-row'>
                                                <button onClick={handleModalArea} className='btn btn-sm btn-outline-primary rounded-pill px-3 fw-medium'>+ Agregar área</button>
                                            </div>
                                        </div>
                                        <div className='table__customA'>
                                            <div className='table__customA__header'>
                                                <div className='table__customA__cell cellA__buttons fw-bold text-blue-500'></div>
                                                <div className='table__customA__cell cellA__id text-center fw-bold text-blue-500'>#</div>
                                                <div className='table__customA__cell cellA__name fw-bold text-blue-500'>Nombre</div>
                                            </div>
                                            <div className='table__customA__body'>
                                            {areas.map((a,i) => {
                                                return <div key={i} className='d-flex flex-row'>
                                                <div className='table__customA__row'>
                                                    <div className='table__customA__cell cellA__buttons'>
                                                        <button onClick={()=>handleModalEditArea(a.id_area)} className='btn__ico--g btn border-0 p-0 btn__edit--icon'><i className="bi bi-pencil"></i></button>
                                                    </div>
                                                    <div className='table__customA__cell cellA__id text-center fw-bold text-blue-500'>{a.id_area}</div>
                                                    <div className='table__customA__cell cellA__name'>{a.nombre_del_Area}</div>
                                                </div>
                                                </div>
                                            })}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                )}
            </listaAreasConsulContext.Provider>
        </>
    )
}

export default ListaAreasConsul